import {Injectable} from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';


import {concat, defer, EMPTY, ignoreElements, Observable, share, take, takeUntil, throwError} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';
import {AuthService} from '../../../services/auth.service';


const catchHttpError = (...status: Array<number>): any => {
    const statusMap = status.reduce((m, v) => m.set(v, v), new Map());
    return (next: (err: HttpErrorResponse) => Observable<any>) =>
        catchError(err => err instanceof HttpErrorResponse && statusMap.has(err.status) ? next(err) : throwError(err));
};


const startWhen = <T>(subscriptionDelay: Observable<any>): any =>
    (source$: Observable<T>) =>
        concat(subscriptionDelay.pipe(take(1), ignoreElements()), source$);

const catch401Error = catchHttpError(401);
// const catch400Error = catchHttpError(400);
// const catch403Error = catchHttpError(403);
// const catch406Error = catchHttpError(406);
// const catch500Error = catchHttpError(500);

@Injectable()
export class AACAuthInterceptor implements HttpInterceptor {
    logoutUser$ = defer(() => {
        return this.auth.isAuthenticated().pipe(map((authenticated)=>{
            if (authenticated) {
                this.auth.signOut();
            }
            return true;
        }))
    });

    refresh$ = defer(() => this.auth.forceRefreshToken()).pipe(catchError(() => this.logoutUser$), share());

    constructor(
        private auth: AuthService,
    ) {}


    addAuthHeader(request): Observable<any> {
        return this.auth.getToken().pipe(
            map((token) => {
                if (
                    request.url.toLowerCase().indexOf('licenseurl') === 0
                    || request.url.toLowerCase().indexOf('awsurl') === 0
                    || request.url.toLowerCase().indexOf('skydataurl') === 0
                    || request.url.toLowerCase().indexOf('utilityurl') === 0
                ){
                    return request.clone({
                        headers: request.headers
                            .set('Content-Type', 'application/json; charset=utf-8')
                            .set('Authorization', 'Bearer ' + token)
                            .set('Issuer',this.auth.authAuthority)
                    });
                }
                if ( request.url.toLowerCase().indexOf('schedulebaseurl') === 0
                    || request.url.toLowerCase().indexOf('cxbaseurl') === 0
                    || request.url.toLowerCase().indexOf('baseurl') === 0
                    || request.url.toLowerCase().indexOf('apibaseurl') === 0
                    || request.url.toLowerCase().indexOf(this.auth.acdBaseURL.toLowerCase())===0
                    || request.url.toLowerCase().indexOf(this.auth.apiBaseURL.toLowerCase())===0
                ) {
                    return request.clone({
                        headers: request.headers
                            .set('Content-Type', 'application/json; charset=utf-8')
                            .set('Authorization', 'Bearer ' + token)
                    });
                }
                else {
                    return request.clone();
                }
            }));
    }
    httpErrorsHandler(): any {
        return (source$: Observable<any>) => source$.pipe(
            catch401Error(() => this.handle401Error(source$)),
            //catch400Error((err) => EMPTY),
            //catch403Error((err) => EMPTY),
            //catch406Error((err) => EMPTY),
            //catch500Error((err) => EMPTY),
        );
    }
    handle401Error(retry$: Observable<any>): Observable<any> {
        return retry$.pipe(
            startWhen(this.refresh$),
            takeUntil(this.auth.isLoggedOut$),
            catch401Error(() => this.logoutUser$),
        );
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.toLowerCase().indexOf('token') >= 0){
            return next.handle(req);
        }
        else if (req.url.toLowerCase().indexOf('cxbaseurl') === -1){
            return defer(() => this.addAuthHeader(req).pipe(switchMap(request => next.handle(request))));
        }
        const nextHandle$ = defer(() => this.addAuthHeader(req).pipe(switchMap(request => next.handle(request))));
        //return iif(() => !this.auth.isLoggedIn, this.logout0User$, nextHandle$).pipe(this.httpErrorsHandler());
        return nextHandle$.pipe(this.httpErrorsHandler());
    }

}
